export interface TextWithButtonsState {
  formEventChildDataButtonText: {
    valid: boolean;
    elementVisual: any;
    dataTosaveVisual: any;
    buttonShow: any;
    docpath: string;
    index: number;
    action: any; 
  } | null;
}

export const initialTextWithButtonsState: TextWithButtonsState = {
  formEventChildDataButtonText: null,
};
